import React, { createContext, useState } from "react";

import "../styles/layout.css";
import Footer from "./page/footer";
import Header from "./page/header/header";
import MobileMenu from "./page/mobile-menu";
import { DarkModeProvider } from "./page/useDarkMode";
import Transition from "./transition";

export const MobileMenuOpenedContext = createContext(null);

export default function Layout(props) {
  const [menuOpened, setMenuOpened] = useState(false);

  return (
    <DarkModeProvider>
      <MobileMenuOpenedContext.Provider
        value={{ menuOpened: menuOpened, setMenuOpened: setMenuOpened }}
      >
        <Header pathName={props.location.pathname} />
        <Transition {...props}>
          <main className={`body ${props.location.pathname}`} id="main">
            {props.children}
          </main>
          <MobileMenu />
          <Footer />
        </Transition>
      </MobileMenuOpenedContext.Provider>
    </DarkModeProvider>
  );
}
